import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import type {
  CategoryCreateInput,
  CategoryUpdateInput,
} from "@/modules/categories/domain/contracts";
import { isDevMode } from "@/shared/lib/config";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { Button } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { ArrowLeftIcon, HelpCircleIcon } from "lucide-react";
import { useCategoriesQuery, useCreateCategory } from "../api/queries";
import { CategoryFormTour, useCategoryFormTour } from "../tour";
import { CategoryForm } from "../ui/CategoryForm";

export function CategoryCreatePage() {
  const nav = useNavigate({ from: "/app/catalog/categories/new" });
  const categoriesQuery = useCategoriesQuery({ limit: 1000 });
  const categories = categoriesQuery.data?.data ?? [];
  const createCategory = useCreateCategory();
  const { run, handleJoyrideCallback, startTour } = useCategoryFormTour();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ຫມວດມູ່", to: "/app/catalog/categories" },
            { label: "ສ້າງໃໝ່" },
          ]}
        />
      </Header>
      <Main>
        <div className="flex flex-wrap items-center justify-between space-y-2">
          <div>
            <h2 className="flex items-center font-bold text-2xl tracking-tight">
              ສ້າງຫມວດມູ່{" "}
              <Button
                variant="ghost"
                size="icon"
                onClick={startTour}
                className="ml-2 size-6"
                title="ເລີ່ມທົດລອງການນຳທາງ"
              >
                <HelpCircleIcon className="h-4 w-4" />
              </Button>
            </h2>
            <p className="text-muted-foreground">
              ເພີ່ມຫມວດມູ່ ຊື່ 3 ພາສາ, ຫມວດມູ່ແມ່ (ບໍ່ບັງຄັບ).
            </p>
          </div>
          <Button
            variant="outline"
            onClick={() => nav({ to: "/app/catalog/categories" } as any)}
          >
            <ArrowLeftIcon className="size-4" />
            ກັບຄືນ
          </Button>
        </div>
        <div className="mt-6 rounded-xl border bg-card p-6">
          <CategoryForm
            categories={categories}
            onSubmit={async (
              values: CategoryCreateInput | CategoryUpdateInput,
            ) => {
              await createCategory.mutateAsync(values as CategoryCreateInput);
              nav({ to: "/app/catalog/categories" } as any);
            }}
            onCancel={() => nav({ to: "/app/catalog/categories" } as any)}
            submitting={createCategory.isPending}
            onDevFill={isDevMode ? () => {} : undefined}
          />
        </div>
        <CategoryFormTour run={run} onCallback={handleJoyrideCallback} />
      </Main>
    </>
  );
}
